import { render, staticRenderFns } from "./DepositOrder.vue?vue&type=template&id=02b97ec4&"
import script from "./DepositOrder.vue?vue&type=script&lang=js&"
export * from "./DepositOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports